export default "\r\n<app-service-category-list></app-service-category-list>\r\n\r\n\r\n";